import React, { useEffect, useState, useRef } from 'react';
import '../styles/Produtos.css';
import SaleModal from './SaleModal'; // Certifique-se de que o caminho está correto
import ModalVendas from '../components/ModalVendas'; // Certifique-se de que o caminho está correto
import ModalRegistraLancamento from '../components/ModalRegistraLancamento'; // Certifique-se de que o caminho está correto
import ModalImpressao from '../components/ModalImpressao'; // Importe o ConfirmImpressao
import { registraLancamento, getProdutos, registravenda, getEmpresaById, retornaXMLAssinado } from '../services/api';
import { imprimeVenda } from '../utils/impressaovenda';
import { hasMinNonNumericChars, divideTexto, divideTextoNew, divideTextoSemRegex, getPrecoUnitario, getPrecos, calculateTotal } from '../utils/functions';
import Toast from '../components/Toast';

function Produtos() {
    const timerRef = useRef(null);
    const inputRef = useRef(null);
    const [isOpen, setIsOpen] = useState(false);
    const [tipo, setTipo] = useState('');
    const [produtos, setProdutos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [login, setLogin] = useState('');
    const [error, setError] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [quantity, setQuantity] = useState(1);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [saleSuccess, setSaleSuccess] = useState(false);
    const [cliente, setCliente] = useState('');
    const [desconto, setDesconto] = useState(0);
    const [formaPagamento, setFormaPagamento] = useState('dinheiro');
    const [isSalesModalOpen, setIsSalesModalOpen] = useState(false);
    const [isModalVendasOpen, setIsModalVendasOpen] = useState(false);
    const [isModalRegistraLanctoOpen, setIsRegistraLanctoOpen] = useState(false);
    const [isVendaAberta, setIsVendaAberta] = useState(false);
    const [isAbrindo, setIsAbrindo] = useState(false);
    const [isCarregandoProdutos, setIsCarregandoProdutos] = useState(false);
    const [isHoraVendaAberta, setIsHoraVendaAberta] = useState('');
    const [isModalImpressaoOpen, setIsModalImpressaoOpen] = useState(false); // Estado para a modal de confirmação
    const [venda_id, setVendaId] = useState('');
    const [toast, setToast] = useState({ message: '', type: '' });



    useEffect(() => {
        if (toast.message) {
            const timer = setTimeout(() => setToast({ message: '', type: '' }), 3000);
            return () => clearTimeout(timer);
        }
    }, [toast]);

    // Função de logout
    const handleLogout = () => {
        if (window.confirm('Tem certeza de que deseja sair?')) {
            localStorage.removeItem('authToken');
            window.location.href = '/login';
        }
    };
    useEffect(() => {
        const username = localStorage.getItem('username');
        setLogin(username);
    }, [])

    // Sempre que abrir uma venda, já foca no input
    useEffect(() => {
        if (isVendaAberta && inputRef.current) {
            inputRef.current.focus();
        }
    }, [isVendaAberta]);

    const manterFoco = () => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    };


    const fetchProdutos = async () => {
        try {
            const data = await getProdutos();
            setProdutos(data.data || []);
            setLoading(false);
            setIsVendaAberta(true)
            setIsCarregandoProdutos(false);
            setIsAbrindo(false);
        } catch (err) {
            if (err.response && err.response.status === 403) {
                // Redireciona para a página de PDV
                window.location.href = '/login';
            } else {
                setIsVendaAberta(false);
                setError(`Erro ao buscar produtos: ${err.message}`);
            }
            setLoading(false);
        }
    };

    const handleSearch = (e) => {
        const term = e.target.value;
        setSearchTerm(term);

        const { textPart, numberPart, tipo } = divideTextoSemRegex(term);
        setTipo(tipo);
        const temLetra = hasMinNonNumericChars(term);

        // Reseta se for busca pequena demais
        if (term.length < 3) {
            setFilteredProducts([]);
            return;
        }

        if (!temLetra) return; // só busca se tiver letra

        const quantidade = (typeof numberPart === "number" && numberPart > 0 && !Number.isNaN(numberPart))
            ? numberPart
            : 1;

        const searchText = textPart?.trim() || term;

        if (timerRef.current) clearTimeout(timerRef.current);

        timerRef.current = setTimeout(async () => {
            try {
                const filtered = await buscarProdutos(searchText);
                const produtos = filtered?.data || [];
                setFilteredProducts(produtos);
                if (produtos.length > 0) setQuantity(quantidade);
            } catch (err) {
                console.error("Erro ao buscar produtos:", err);
                setFilteredProducts([]);
            }
        }, 500); // debounce fixo em 500ms
    };


    const handleKeyPress = async (e) => {
        if (e.key === 'Enter' && filteredProducts.length > 0) {
            addToCart(filteredProducts[0]);
        }

        //função que busca produto pelo código interno da balança
        if (e.key === 'Enter' && filteredProducts.length === 0) {

            const inputValue = document.getElementById('busca-produto').value;
            // if (inputValue.length >= 13) {

            let quantidade = parseFloat(inputValue.slice(7, 12)) / 1000;
            if (inputValue.startsWith('23')) {
                quantidade = 1;
            }
            const separarProduto = inputValue.split("*");
            // Exemplo: 0.589*7896050700303
            // separarProduto[0] = 0.589  (quantidade em gramas)
            // separarProduto[1] = 7896050700303 (código do produto)
            if (separarProduto.length > 1) {
                quantidade = parseFloat(separarProduto[0]); //parseFloat(inputValue.slice(7, 12)) / 1000;
            }

            const { textPart, numberPart, tipo } = divideTextoSemRegex(inputValue);
            setTipo(tipo);

            const filtered = await buscarProdutos(textPart);
            if (filtered.data.length > 0) {
                const produto = filtered.data[0];
                setQuantity(quantidade.toString()); // Ajuste a quantidade conforme necessário
                addToCart(produto, produto.uCom === 'UN' ? numberPart : quantidade);
            }
            // }
        }
    };

    const handleKeyDown = (e) => {
        try {
            if (e.key === 'F8') handleOpenSalesModal();
            if (e.key === 'F9') handleOpenModalVendas();
            if (e.key === 'F2') handleOpenVendas();
            if (e.key === 'F4') handleOpenModalRegistraLancto();
        } catch (error) {
            console.error('Erro em handleKeyDown:', error);
        }
    };

    useEffect(() => {
        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    const clearSearch = () => {
        setSearchTerm('');
        setFilteredProducts([]);
        setQuantity(1);
    };

    const addToCart = (produto, quantidadeForcada = null) => {
        manterFoco();
        const quantidadeFinal = quantidadeForcada !== null ? quantidadeForcada : quantity;

        let DataHora = new Date()
        if (isHoraVendaAberta) {
        }

        let valorVendaConvertido;

        switch (true) {
            case !!produto.precoPromocao:
                valorVendaConvertido = Number(produto.precoPromocao);
                break;
            case tipo === 'fracionado' && produto.fracionado:
                valorVendaConvertido = Number(produto.Precos?.[0]?.preco_venda_fracionado ?? produto.vlrVenda);
                break;
            case tipo === 'atacado' && produto.atacado:
                valorVendaConvertido = Number(produto.Precos?.[0]?.preco_atacado ?? produto.vlrVenda);
                break;
            case produto.Precos && produto.Precos.length > 0:
                valorVendaConvertido = Number(produto.Precos[0].preco_venda);
                break;
            default:
                valorVendaConvertido = Number(produto.vlrVenda);
        }

        const total = calculateTotal(valorVendaConvertido, quantidadeFinal)

        /*if (produto.uCom === 'UN') {
            total = produto.vlrVenda;
        }*/
        // 07-04-2025 alterei de quantity para quantidade e total para valorTotal
        setSelectedProducts((prev) => [
            ...prev,
            { ...produto, quantidade: quantidadeFinal, valorTotal: total, tipoVenda: tipo || 'normal' },
        ]);
        clearSearch();
    };

    const removeFromCart = (produtoId, index) => {
        setSelectedProducts((prev) => prev.filter((item, i) => !(item.id === produtoId && i === index)));
    };

    const handleOpenSalesModal = () => {
        setIsSalesModalOpen(true);
    };

    const handleOpenModalVendas = () => {
        setIsModalVendasOpen(true);
    };

    const handleOpenModalRegistraLancto = () => {
        setIsRegistraLanctoOpen(true);
    };


    const handleCloseRegistraLancto = () => {
        setIsRegistraLanctoOpen(false);
    };
    const handleCloseSalesModal = () => {
        setIsSalesModalOpen(false);
        manterFoco();
    };

    const handleCloseModalVendas = () => {
        setIsModalVendasOpen(false);
    };

    const handleOpenVendas = () => {
        setIsAbrindo(true);
        setIsCarregandoProdutos(true);
        const DataHora = new Date().toLocaleTimeString("pt-BR").replace(/([\d]+:[\d]{2})(:[\d]{2})(.*)/, "$1$3");
        fetchProdutos();
        setIsHoraVendaAberta(DataHora);
    };

    function converterData(dataString) {
        const partes = dataString.split(/[\/ :]/); // Divide a string em dia, mês, ano, hora, minuto e segundo
        const dia = partes[0];
        const mes = partes[1];
        const ano = partes[2];
        const hora = partes[3];
        const minuto = partes[4];
        const segundo = partes[5];

        return `${ano}-${mes}-${dia} ${hora}:${minuto}:${segundo}`; // Usa template literals para formatar
    }


    const handleSubmitLancamento = async (formElements) => {
        let dataHoje = new Date().toLocaleString().replace(',', '');
        let dataAjustada = converterData(dataHoje)
        // Extrai os valores dos elementos do formulário
        const descricao = formElements.descricao.value;
        const valor = parseFloat(formElements.valor.value);
        const tipo = formElements.tipo.value;

        const lancamentoData = {
            descricao,
            valor,
            tipo,
            dataLancamento: dataAjustada
        };

        try {
            const response = await registraLancamento(lancamentoData);
            if (response.status === 201) {
                setIsRegistraLanctoOpen(false);
            }
        } catch (error) {
            console.error("Erro ao registrar lançamento:", error);
        }
    };

    const calculateTotals = () => {
        const totalQuantity = selectedProducts.reduce(
            (acc, item) => acc + (Number.isInteger(item.quantity) ? item.quantity : 1),
            0
        );

        const totalPrice = selectedProducts.reduce(
            (acc, item) => acc + parseFloat(item.valorTotal),
            0
        );

        return { totalQuantity, totalPrice: parseFloat(totalPrice) };
    };

    const confirmImpressao = () => {
        imprimeVenda(venda_id)
        setIsModalImpressaoOpen(false);
        setSelectedProducts([]); // Limpa os produtos selecionados
    };

    const cancelImpressao = () => {
        setIsModalImpressaoOpen(false);
        setIsVendaAberta(false);
        setSelectedProducts([]); // Limpa os produtos selecionados
    };


    async function buscarProdutos(termo) {
        const filtered = await getProdutos({ termo }, 1);

        return filtered;
    }
    const { totalQuantity, totalPrice } = calculateTotals();

    return (
        <div className="min-h-screen flex flex-col bg-gray-100">
            {/* Header */}
            <header className="sticky top-0 z-10 bg-gradient-to-r from-blue-600 to-indigo-600 shadow-md p-3 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">

                {/* Mobile header */}
                <div className="flex md:hidden justify-between items-center w-full">
                    <span className="font-bold text-white">Menu</span>
                    <button
                        onClick={() => setIsOpen(!isOpen)}
                        className="px-3 text-white text-2xl"
                    >
                        ☰
                    </button>
                </div>

                {/* Botões - mobile abre com isOpen, desktop sempre visível */}
                {(isOpen || window.innerWidth >= 768) && (
                    <div className="flex flex-col sm:flex-row gap-2 flex-wrap">
                        <button
                            onClick={handleOpenVendas}
                            disabled={isVendaAberta}
                            className="px-4 py-2 bg-green-600 text-white rounded-lg shadow hover:bg-green-700 disabled:opacity-50"
                        >
                            F2 Iniciar Venda
                        </button>
                        <button
                            onClick={handleOpenModalRegistraLancto}
                            disabled={isVendaAberta}
                            className="px-4 py-2 bg-blue-600 text-white rounded-lg shadow hover:bg-blue-700 disabled:opacity-50"
                        >
                            F4 Caixa
                        </button>
                        <button
                            onClick={handleOpenModalVendas}
                            className="px-4 py-2 bg-indigo-600 text-white rounded-lg shadow hover:bg-indigo-700"
                        >
                            F9 Relatório de Venda
                        </button>
                    </div>
                )}

                {/* Login e sair */}
                <div className="flex items-center justify-between sm:justify-end gap-3">
                    <span className="text-white font-semibold">{login}</span>
                    <button
                        onClick={handleLogout}
                        className="px-4 py-2 bg-red-600 text-white rounded-lg shadow hover:bg-red-700"
                    >
                        Sair
                    </button>
                </div>
            </header>


            {/* Conteúdo principal - grid responsivo */}
            <main className="flex-1 grid grid-cols-1 md:grid-cols-2 gap-4 p-4">
                {/* Produtos */}
                <section className="bg-white rounded-2xl shadow p-4 flex flex-col">
                    <h1 className="text-lg font-bold mb-2">Produtos</h1>
                    {isHoraVendaAberta && (
                        <h2 className="text-sm text-gray-500 mb-2">
                            Venda iniciada às {isHoraVendaAberta} horas
                        </h2>
                    )}

                    {/* Busca */}
                    <div className="flex gap-2 mb-3">
                        <input
                            id="busca-produto"
                            ref={inputRef}
                            type="text"
                            placeholder={
                                isVendaAberta
                                    ? "Buscar por nome ou código de barras"
                                    : "Pressione F2 para iniciar a Venda"
                            }
                            value={isVendaAberta ? searchTerm.replace(",", ".") : ""}
                            onChange={isVendaAberta ? handleSearch : undefined}
                            onKeyDown={isVendaAberta ? handleKeyPress : undefined}
                            disabled={!isVendaAberta}
                            className="flex-1 px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-blue-300 disabled:bg-gray-100"
                        />
                        {searchTerm && (
                            <button
                                onClick={clearSearch}
                                className="px-3 py-2 bg-gray-200 rounded-lg hover:bg-gray-300"
                            >
                                Limpar
                            </button>
                        )}
                    </div>

                    {/* Status carregamento */}
                    {isAbrindo ? (
                        isCarregandoProdutos && (
                            <p className="text-gray-500">Carregando produtos...</p>
                        )
                    ) : (
                        !isVendaAberta && (
                            <p className="text-gray-500">Venda não iniciada...</p>
                        )
                    )}

                    {error && <p className="text-red-600">{error}</p>}

                    {/* Lista de produtos */}
                    {!loading && !error && filteredProducts.length > 0 && (
                        <div className="flex-1 overflow-y-auto space-y-3">
                            {filteredProducts.map((produto) => {
                                // Calcula preços antes do JSX
                                const precoBase = produto.fracionado && tipo === 'fracionado'
                                    ? Number(produto.Precos?.[0]?.preco_venda_fracionado ?? produto.vlrVenda)
                                    : produto.atacado && tipo === 'atacado'
                                        ? Number(produto.Precos?.[0]?.preco_atacado ?? produto.vlrVenda)
                                        : Number(produto.Precos?.[0]?.preco_venda ?? produto.vlrVenda);

                                const precoUnitario = produto.precoPromocao
                                    ? Number(produto.precoPromocao)
                                    : precoBase;

                                const valorTotal = calculateTotal(precoUnitario, quantity);

                                return (
                                    <div
                                        key={produto.id}
                                        className="flex items-center justify-between p-4 bg-white border rounded-2xl shadow-sm hover:shadow-md transition"
                                    >
                                        <div>
                                            {/* Nome */}
                                            <p className="text-lg font-semibold text-gray-800">{produto.xProd}</p>

                                            {/* Preço unitário */}
                                            {precoUnitario !== precoBase ? (
                                                <div className="flex flex-col">
                                                    <p className="text-sm text-gray-400 line-through">
                                                        R$ {precoBase.toFixed(2)}
                                                    </p>
                                                    <p className="text-sm font-bold text-green-600">
                                                        R$ {precoUnitario.toFixed(2)}
                                                    </p>
                                                </div>
                                            ) : (
                                                <p className="text-sm text-gray-500">
                                                    R$ {precoUnitario.toFixed(2)}
                                                </p>
                                            )}

                                            {/* Total */}
                                            <div className="mt-1">
                                                <p className="text-sm text-gray-700">
                                                    Total:{" "}
                                                    <span className="font-semibold text-blue-600">
                                                        R$ {valorTotal.toFixed(2)}
                                                    </span>
                                                </p>
                                            </div>
                                        </div>

                                        <button
                                            onClick={() => addToCart(produto)}
                                            className="flex items-center gap-2 px-3 py-1.5 bg-gray-500 text-white text-sm font-medium rounded-xl hover:bg-gray-600 transition"
                                        >
                                            ➕ <span>Adicionar</span>
                                        </button>
                                    </div>
                                );
                            })}
                        </div>

                    )}
                </section>

                {/* Carrinho */}
                <section className="bg-white rounded-lg shadow p-4 flex flex-col font-mono text-sm border border-gray-300">
                    <h2 className="text-base font-bold mb-3 text-center border-b border-dashed border-gray-400 pb-2">
                        🧾 Carrinho
                    </h2>

                    {selectedProducts.length > 0 ? (
                        <div className="flex-1 overflow-y-auto">
                            <table className="w-full border-collapse">
                                <thead>
                                    <tr className="border-b border-dashed border-gray-400 text-left">
                                        <th className="p-1">Item</th>
                                        <th className="p-1">Produto</th>
                                        <th className="p-1">Qtd</th>
                                        <th className="p-1">Unitário</th>
                                        <th className="p-1">Total</th>
                                        <th className="p-1 text-center">X</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {selectedProducts.map((produto, index) => (
                                        <tr key={produto.id} className="border-b border-dashed border-gray-300">
                                            <td className="p-1">{index + 1}</td>
                                            <td className="p-1">{produto.xProd}{produto.tipoVenda === 'fracionado' ? ' - UN' : produto.tipoVenda === 'normal' ? '' : ' - Atacado'}</td>
                                            <td className="p-1">{produto.quantidade.toFixed(3)}</td>
                                            <td className="p-1">
                                                {(() => {
                                                    // Se tiver preços cadastrados
                                                    if (produto.Precos?.length > 0) {
                                                        const preco = produto.Precos[0];

                                                        // Determina o preço unitário com base no tipo de venda
                                                        let valorUnitario;
                                                        if (produto.tipoVenda === 'normal' && !produto.promocaoId) {
                                                            valorUnitario = Number(preco.preco_venda);
                                                        } else if (produto.tipoVenda === 'fracionado') {
                                                            valorUnitario = Number(preco.preco_venda_fracionado);
                                                        } else if (produto.tipoVenda === 'atacado') {
                                                            valorUnitario = Number(preco.preco_atacado);
                                                        } else if (produto.promocaoId) {
                                                            valorUnitario = Number(produto.precoPromocao);
                                                        } else {
                                                            valorUnitario = Number(produto.vlrVenda);
                                                        }

                                                        return new Intl.NumberFormat("pt-BR", {
                                                            style: "currency",
                                                            currency: "BRL",
                                                        }).format(valorUnitario);
                                                    }

                                                    // Caso não tenha preços cadastrados
                                                    const valorUnitarioFallback = produto.promocaoId
                                                        ? Number(produto.precoPromocao)
                                                        : Number(produto.vlrVenda);

                                                    return new Intl.NumberFormat("pt-BR", {
                                                        style: "currency",
                                                        currency: "BRL",
                                                    }).format(valorUnitarioFallback);
                                                })()}
                                            </td>
                                            <td className="p-1">
                                                {new Intl.NumberFormat("pt-BR", {
                                                    style: "currency",
                                                    currency: "BRL",
                                                }).format(produto.valorTotal)}
                                            </td>
                                            <td className="p-1 text-center">
                                                <button
                                                    onClick={() => removeFromCart(produto.id, index)}
                                                    className="px-2 py-0.5 text-xs bg-gray-400 text-white rounded hover:bg-gray-900"
                                                >
                                                    🗑
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <p className="text-gray-500 text-center py-4">--- O carrinho está vazio ---</p>
                    )}

                    {/* Resumo estilo cupom */}
                    <div className="mt-3 pt-2 border-t border-dashed border-gray-400 text-center">
                        <p>
                            Itens: <span className="font-bold">{totalQuantity}</span>
                        </p>
                        <p>
                            Total:{" "}
                            <span className="font-bold text-lg">
                                {totalPrice.toLocaleString("pt-BR", {
                                    style: "currency",
                                    currency: "BRL",
                                })}
                            </span>
                        </p>
                        <button
                            onClick={handleOpenSalesModal}
                            className="mt-3 w-full px-4 py-2 bg-black text-white font-bold rounded hover:bg-gray-800 disabled:opacity-50"
                            disabled={selectedProducts.length === 0}
                        >
                            F8 - Fechar Venda
                        </button>
                    </div>
                </section>

            </main>

            {/* Rodapé */}
            <footer className="bg-white shadow-inner text-center p-2 text-sm text-gray-600">
                <p>S&S Tecnologia / Pixel</p>
            </footer>

            {/* Modais */}
            {isSalesModalOpen && (
                <SaleModal
                    isOpen={isSalesModalOpen}
                    onClose={handleCloseSalesModal}
                    totalQuantity={totalQuantity}
                    totalPrice={totalPrice.toFixed(2)}
                    selectedProducts={selectedProducts}
                    desconto={desconto}
                    cliente={cliente}
                    formaPagamento={formaPagamento}
                    onSuccess={() => {
                        // Aqui o PDV só precisa reagir à venda concluída
                        setIsVendaAberta(false);
                        setFilteredProducts([]);
                        setSelectedProducts([]); // Limpa os produtos selecionados
                        setIsSalesModalOpen(false); // Fecha modal
                        setToast({ message: 'Venda concluída com sucesso!', type: 'success' })
                    }}
                />
            )}
            {isModalVendasOpen && (
                <ModalVendas
                    isOpen={isModalVendasOpen}
                    onClose={handleCloseModalVendas}
                    totalQuantity={totalQuantity}
                    totalPrice={totalPrice}
                    selectedProducts={selectedProducts}
                    desconto={desconto}
                    cliente={cliente}
                    formaPagamento={formaPagamento}
                />
            )}
            {isModalRegistraLanctoOpen && (
                <ModalRegistraLancamento
                    isOpen={isModalRegistraLanctoOpen}
                    onClose={handleCloseRegistraLancto}
                    onSubmit={handleSubmitLancamento}
                />
            )}
            {isModalImpressaoOpen && (
                <ModalImpressao
                    message="Você deseja imprimir está Venda ?"
                    onConfirm={confirmImpressao}
                    onCancel={cancelImpressao}
                />
            )}

            {saleSuccess && (
                <p className="text-center text-green-600 font-medium py-2">
                    Venda concluída com sucesso!
                </p>
            )}
            {toast.message && <Toast type={toast.type} message={toast.message} />}
        </div>
    );

};

export default Produtos;
